const questionsResult = {
  CORRECT: "Correct!",
  WRONG: "Wrong!",
  TIMEOUT: "Ran out of time",
};

const doOverActions = {
  SKIP: "Skip",
  USE: "New question",
};

const firestoreData = {
  COLLECTION_NAME: process.env.VUE_APP_FIREBASE_COLLECTION,
};

export { questionsResult, doOverActions, firestoreData };
